/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_DROP_IN = 'letterDropIn';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterDropInPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_DROP_IN,

  // A human friendly name for the preset.
  humanName: 'Letter - Drop In',

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'letter.opacity': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutExpo,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.2000',
      },

      // The value of the property that will change during the transition.
      values: [0, 1],

      // Whether or not to stagger the transition for each letter or the stagger delay in milliseconds.
      stagger: 70,

      // The amount of time in milliseconds that each letter will animate, or false to auto-calculate.
      staggerDuration: false,
    },
    'letter.scale': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutExpo,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.2000',
      },

      // The value of the property that will change during the transition.
      values: [4, 1],

      // Whether or not to stagger the transition for each letter or the stagger delay in milliseconds.
      stagger: 70,

      // The amount of time in milliseconds that each letter will animate, or false to auto-calculate.
      staggerDuration: false,
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_DROP_IN,
    options: {},
  },
};

letterDropInPresetDetails.template.options = lodash.cloneDeep(letterDropInPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_DROP_IN;

// This defines the value of the presets object.
export default letterDropInPresetDetails;
